

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"29","height":"29","viewBox":"0 0 29 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('g', {"clip-path":"url(#svg-info-sign-2y5qRX1)"}, ["\n", h('path', {"d":"M14.3281 1.70117C16.4124 1.70117 18.1081 3.39688 18.1081 5.48117C18.1081 7.56546 16.4124 9.26117 14.3281 9.26117C12.2438 9.26117 10.5481 7.56546 10.5481 5.48117C10.5481 3.39688 12.2438 1.70117 14.3281 1.70117ZM19.3681 26.9012H9.28809V24.7412H11.4481V13.9412H9.28809V11.7812H17.2081V24.7412H19.3681V26.9012Z","fill":"#2472AB"}, []), "\n"]), "\n", h('defs', {}, ["\n", h('clipPath', {"id":"svg-info-sign-2y5qRX1"}, ["\n", h('rect', {"width":"28","height":"28","fill":"white","transform":"translate(0.328125 0.30127)"}, []), "\n"]), "\n"]), "\n"]);
};

        